import React from 'react'

import clsx from 'clsx'

import Grid from 'components/Grid'

import Content from './components/Content'
import Summary from './components/Summary'

import classes from './Main.module.scss'

const Main = ({ children, className, style }) => (
  <Grid item xs className={clsx('Main', classes.root, className)} style={style}>
    <Grid container spacing={3}>
      {children}
    </Grid>
  </Grid>
)

Main.Summary = Summary
Main.Content = Content

export default Main
